export enum OperationalStatus {
  Operational = 1,
  InMaintenance = 2
}